import { toast } from "react-toastify";
// import { getClientDetailsAPI, getClusterwiseApi } from "../../api/organisationApi";
import { errMsg } from "../../utils/helperFunction";
import axios from "axios";
import {
  addClientApi,
  getClientDetailsApi,
  getClientSWOTApi,
  getClientClusterwiseApi,
  getZScoreApi,
  getTrendApi,
  updateClientApi,
  getClientProductsApi
} from "../../api/clientApi";
// import { getTrendApi, getZScoreApi } from "../../api/kpiApi";

export const getClientDetails = (clientId) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_REQ",
    });

    const data = await getClientDetailsApi(clientId);

    dispatch({
      type: "CLIENT_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_ERROR",
      payload: { error: true, message: message },
    });
  }
};

export const getClientSWOT = (clientId) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_SWOT_REQ",
    });

    const data = await getClientSWOTApi(clientId);

    dispatch({
      type: "CLIENT_SWOT_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_SWOT_ERROR",
      payload: { error: true, message: message },
    });
  }
};

export const addClient = (reqBody, navigate) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_ADD_REQ",
    });

    const data = await addClientApi(reqBody);

    dispatch({
      type: "CLIENT_ADD_SUC",
      payload: data,
    });
    navigate(`/client/${data.data}/sme-background`);
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_ADD_ERROR",
      payload: { error: true, message: message },
    });
  }
};

export const getClientClusterwise = (clientId) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_CLUSTERWISE_REQ",
    });

    const data = await getClientClusterwiseApi(clientId);

    dispatch({
      type: "CLIENT_CLUSTERWISE_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_CLUSTERWISE_ERROR",
      payload: { error: true, message: message },
    });
  }
};

export const getClientZScore = (clientId) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_ZSCORE_REQ",
    });

    const data = await getZScoreApi(clientId);

    dispatch({
      type: "CLIENT_ZSCORE_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_ZSCORE_ERROR",
      payload: { error: true, message: message },
    });
  }
};


export const getClientTrend = (clientId) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_TREND_REQ",
    });

    const data = await getTrendApi(clientId);

    dispatch({
      type: "CLIENT_TREND_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    // toast.error(message, {
    //   position: "bottom-center",
    //   toastId: message,
    // });

    dispatch({
      type: "CLIENT_TREND_ERROR",
      payload: { error: true, message: message },
    });
  }
};


export const updateClient = (clientId, formData) => async (dispatch) => {
  try {
    dispatch({
      type: "CLIENT_UPDATE_REQ",
    });

    const data = await updateClientApi(clientId, formData);

    dispatch(getClientDetails(clientId));

    dispatch({
      type: "CLIENT_UPDATE_FETCH_SUC",
      payload: data,
    });

    toast.success("Profile updated successfully!", {
      position: "bottom-center",
    });
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      position: "bottom-center",
      toastId: message,
    });

    dispatch({
      type: "CLIENT_UPDATE_ERROR",
      payload: { error: true, message },
    });
  }
};







